import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import PaymentMethodSalesTable from "components/Tables/PaymentMethodSalesTable";

function PaymentMethodStatsPage() {
  return (
    <>
      <Container fluid>
        <Row>
          <Col xs={12} md={12}>
            <PaymentMethodSalesTable />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default PaymentMethodStatsPage;
